module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8cGF0aCBmaWxsPSIjMDA0RkEzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCA4LjU4NkwxNy42NTcuOTI5YTEgMSAwIDAgMSAxLjQxNCAxLjQxNEwxMS40MTQgMTBsNy42NTcgNy42NTdhMSAxIDAgMCAxLTEuNDE0IDEuNDE0TDEwIDExLjQxNGwtNy42NTcgNy42NTdBMSAxIDAgMSAxIC45MyAxNy42NTdMOC41ODYgMTAgLjkyOSAyLjM0M0ExIDEgMCAxIDEgMi4zNDMuOTNMMTAgOC41ODZ6Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close-icon-blue.svg
// module id = 726
// module chunks = 33